// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1zGpn","split":"Item_split__3W-mw","coin":"Item_coin__olVXi","percent":"Item_percent__1wk3F","count":"Item_count__2W1Vw","dot":"Item_dot__2hIPc"};